<template>
  <Layout :removePadding="true" :onlyLogoHeader="true">
    <div class="d-flex flex-column" style="height: 100%;">
      <div class="flex-grow-1">

        <div
          v-if="userId != null && userId != 'NO_TOOLKIT_USER_FOUND'"
          class="d-flex flex-column justify-center align-center fill-height text-center"
        >
          <v-img max-width="100" max-height="100" :src="successImage"></v-img>
          <div
            style="color: var(--primary-color-blue);"
            class="text-center display font-weight-bold"
            :class="$vuetify.breakpoint.smAndDown ? 'pt-3 pb-0' : 'pt-10 pb-5'"
          >
            {{ $t("sign_up." + type + ".success") }}
          </div>
        </div>
        <div v-else>
          <div
            style="color: var(--primary-color-blue);"
            class="text-center display font-weight-bold"
            :class="$vuetify.breakpoint.smAndDown ? 'pt-3 pb-0' : 'pt-10 pb-5'"
          >
            {{ $t("sign_up." + type + ".title") }}
            <p style="color: var(--primary-color-blue);" class="text-center font-weight-light subtitle-2 pt-2">
              {{ $t("sign_up." + type + ".subtitle") }}
            </p>
          </div>
          <div
            class="mx-10"
            :class="$vuetify.breakpoint.smAndDown ? 'mt-9' : 'mt-13'"
          >
            <v-col class="py-5">
              <v-row class="pl-3" style="color: var(--primary-color-blue); font-size: 14px;">
                {{ $t("sign_up_options." + type) }}*
              </v-row>
              <v-row align="center">
                <v-alert
                  v-if="userId == 'NO_TOOLKIT_USER_FOUND'"
                  border="bottom"
                  outlined
                  text
                  type="warning"
                >
                  <span class="text-orange-darken-2 font-weight-medium">
                    {{ $t("sign_up." + type + ".failed") }}
                  </span>
                </v-alert>
                <v-text-field
                  flat
                  solo
                  hide-details
                  single-line
                  v-model="userIdentifier"
                  class="input-custom"
                  :append-icon="type === 'tag' ? 'info_outline' : ''"
                  @click:append="dialog = !dialog"
                  :placeholder="$t('sign_up.placeholder_example')"
                ></v-text-field>
                <QrScanner class="pa-1" @scanned="onQrScanned" />
                <span v-if="formErrors" class="red--text pl-1 col-12">{{
                  formErrors.userIdentifier
                }}</span>
              </v-row>
            </v-col>
          </div>
    
          <div class="mt-2 mx-10">
            <v-btn
              class="px-13 py-7 mb-5 w-100"
              style="color: white !important; background: var(--primary-color-blue); border-radius: 16px !important;"
              outlined
              x-large
              outlined-border-width="7"
              :loading="sentRequest"
              @click="getUserByKey()"
            >
              <v-icon class="px-1">search</v-icon>
              {{ $t("sign_up.search") }}
            </v-btn>
          </div>
          <p
            class="text-center pt-10 clickable"
            style="text-decoration: underline; color: var(--primary-color-blue); font-weight: 300;"
            @click="
              $router.push({
                name: $route.params.singleType
                  ? routeNames.LOGIN
                  : routeNames.SELECT_SIGN_UP,
              })
            "
          >
            {{ $t("sign_up.go_back") }}
          </p>
          <TagInfoDialog v-if="this.type == 'tag'" :triggerDialog="dialog" />
        </div>
      </div>
      <BottomBar :logged="false"/>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/MainLayout";
import TagInfoDialog from "@/components/dialogs/TagInfoDialog";
import QrScanner from "@/components/QrScanner";
import BottomBar from "@/components/BottomBar";

export default {
  name: "ValidateTagOrTicket",
  props: ["routeNames", "auth"],
  data() {
    return {
      type: null,
      dialog: false,
      formErrors: {},
      userIdentifier: null,
      sentRequest: false,
      successImage: require("@/assets/images/success.png"),
      userId: null,
    };
  },
  methods: {
    onQrScanned(result) {
      console.log("QR Escaneado:", result);
      this.userIdentifier = result;
    },
    validateTicket() {
      this.formErrors.userIdentifier = !this.userIdentifier
        ? this.$t("error.bad_request.any.required")
        : null;
      return this.userIdentifier;
    },
    validateTagId() {
      if (!this.userIdentifier) {
        this.formErrors.userIdentifier = this.$t(
          "error.bad_request.any.required"
        );
        return false;
      }
      if (this.userIdentifier.match(/\b[0-9A-F]{15}\b/gi)) {
        var tagId = this.userIdentifier.slice(0, -1);
        var decimalTagId = parseInt(tagId, 16);
        var checkdigit = this.userIdentifier.slice(-1);
        var isValid = luhn(decimalTagId.toString().concat(checkdigit));
        if (isValid) {
          return true;
        } else {
          this.formErrors.userIdentifier = this.$t(
            "error.bad_request.string.invalid_tag"
          );
          return false;
        }
      } else if (this.userIdentifier.match(/\b[0-9A-F]{14}\b/gi)) {
        return true;
      } else {
        this.formErrors.userIdentifier = this.$t(
          "error.bad_request.string.hex"
        );
        return false;
      }
    },
    getUserByKey() {
      this.formErrors = {};
      if (this.type === "tag" && !this.validateTagId()) return;
      if (this.type === "locator" && !this.validateTicket()) return;
      this.sentRequest = true;
      var type;
      var value;
      if (this.type === "tag") {
        type = "TAG";
      } else if (this.type === "locator") {
        type = "TICKET";
      }
      value = this.userIdentifier;
      const context = this;
      this.auth
        .getUserByKey(this, type, value)
        .then((data) => {
          context.sentRequest = false;

          this.userId = data.body.user_id;

          setTimeout(() => {
            this.$router.push({
              name: this.routeNames.SIGN_UP,
              params: {
                type: this.type,
                identifier: value,
              },
            });
          }, 1000);
        })
        .catch((e) => {
          this.userId = "NO_TOOLKIT_USER_FOUND";
        })
        .finally(() => {
          context.sentRequest = false;
        });
    },
  },
  async created() {
    this.type = this.$route.params.type;
  },
  components: {
    Layout,
    TagInfoDialog,
    QrScanner,
    BottomBar
  },
};
</script>
